<app-toolbar></app-toolbar>
<div class="content">
  <app-card></app-card>
</div>
<app-footer></app-footer>
